module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIxLjg4NzUgNC44Mzc1TDE5LjY2MjUgMi42MjVMNy4zMDAwNSAxNUwxOS42NzUgMjcuMzc1TDIxLjg4NzUgMjUuMTYyNUwxMS43MjUgMTVMMjEuODg3NSA0LjgzNzVaIiBmaWxsPSIjNjg2ODY4Ii8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/back.svg
// module id = dqYA
// module chunks = 0